module.exports = __webpack_public_path__ + "img/product-category-engagementrings.c4115ab.jpg";